









































import { Component, Vue } from "@zoovu/runner-browser-api";

import { ChoiceQuestionView } from "@zoovu/runner-web-design-base";

@Component({
  name: "ChoiceQuestionView",
  mixins: [ChoiceQuestionView],
})
export default class ChoiceQuestionViewExtended extends Vue {
  private updateImageBox(): void {
    /* eslint-disable no-param-reassign */
    this.imageHeights = (this.$refs.answerElement as Vue[]).reduce(
      (imageHeights, { $children: [choiceAnswer] }, index) => {
        if (!choiceAnswer.$refs.imageBoxElement) {
          return imageHeights;
        }

        const topKey = this.answersPerRow[index];

        const answers = this.getAnswersInTheSameRow(index);

        imageHeights[topKey] = this.hasImageInRow(answers[0], answers[1]) ? "250px" : "0px";

        return imageHeights;
      },
      []
    );
    /* eslint-enable no-param-reassign */
  }
}
